import { Button, ButtonProps, Tooltip } from "@mui/material";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { LoginOutlined } from "@mui/icons-material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ModalContext } from "../../Modals";
import ModalCreateOrUpdateExternalAccess, {
  ModalCreateOrUpdateExternalAccessElementProps,
} from "../../Modals/ModalCreateOrUpdateExternalAccess/modal-create-or-update-external-access";
import { UserHasAcl } from "../../../Utils/helpers";
import { AclTypes } from "../../../Core/Api/Types/acl-types";

interface CreateAccessButtonProps extends Omit<ButtonProps, "onClick" | "startIcon"> {
  assets: DbAssetObjectInfos[];
}

const CreateAccessButton = (props: CreateAccessButtonProps) => {
  const { t } = useTranslation();
  const { assets, disabled, ...buttonProps } = props;

  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };

  if (!UserHasAcl(AclTypes.aclExternalAccessCreateOrUpdate)) return null;

  const handleOnClick = () => {
    if (!openModal) return;

    openModal<ModalCreateOrUpdateExternalAccessElementProps>(ModalCreateOrUpdateExternalAccess, {
      assets: assets,
    });
  };

  return (
    <Tooltip title={t("tooltip:driveOnlyExternalAccess")} arrow disableHoverListener={!disabled}>
      <div>
        <Button {...buttonProps} disabled={disabled} startIcon={<LoginOutlined />} onClick={handleOnClick}>
          {t("button:createAccess")}
        </Button>
      </div>
    </Tooltip>
  );
};

export default CreateAccessButton;
